import { SetInnerHtml } from "../utilities/common.js";
import "./intelligent-common.js";

if (document.getElementById('divHomeDashboard') == null) {
    let ele = document.getElementById("accordionBodyHomeIfdMfe");
    if (ele != null) {
        let url = ele.dataset.mfeurl;
        let appName = document.getElementById('divHomeProductMfeContainer').dataset.appname;
        let productSelectorUrl =
            `${url}/support/productsmfe/${Dell.Metrics.sc.language}-${Dell.Metrics.sc.country}/homedashboard?appname=${appName}&searchproduct=true&detectpc=true&supportservice=true&browseallproducts=true&recentlyviewed=true&registereddevices=true&version=4.0`;
        loadMfe(`${productSelectorUrl}`)
            .then((data) => {
                ele.innerHTML = "";
                SetInnerHtml(ele, data);
            })
            .catch((error) => {
                console.error("Loading Home Mfe Error :- ", error);
            });
    }
}

async function loadMfe(url) {
    const response = await fetch(url,
        {
            credentials: 'include',
            headers: {
                'X-Robots-Tag': 'noindex'
            }
        });
    if (response.status === 200) {
        const json = await response.text();
        return json;
    }
}

let path = window.location.pathname;
if (path.indexOf('/products/') > -1) {
    window.BrowseAllProductUrlPush = true;
}

const visitCorpBusinessLink = document.getElementById('businessvisitlink');
if (visitCorpBusinessLink != null) {
    visitCorpBusinessLink.addEventListener("click", function () {
        document.cookie = `sup-ent=1;domain=.dell.com;path=/`;
    });
}

window.addEventListener("browse-all-product-push-event", () => {
    const path = window.location.pathname;
    const hrefUrl = window.location.href;
    if (path.indexOf('/products/') > -1) {
        if (document.getElementById("btn-browseallproducts-open")) {
            document.getElementById("btn-browseallproducts-open").click();
        }
        else if (document.getElementById("divTabHomeDashboard-0") && document.getElementById("divTabHomeDashboard-0").ariaSelected === "false") {
            document.getElementById("divTabHomeDashboard-0").click();
            let count = 0;
            const checkInterval = setInterval(() => {
                const element = document.getElementById("btn-browseallproducts-open");
                if (element) {
                    setTimeout(() => { element.click(); }, 500);
                    clearInterval(checkInterval);
                }
                count++;
                if (count === 10)
                    clearInterval(checkInterval);
            }, 500);
        }
    }
    else if (hrefUrl.indexOf('IsInvalidSelection=True') > -1) {
        if (document.getElementById("divTabHomeDashboard-0") && document.getElementById("divTabHomeDashboard-0").ariaSelected === "false")
            document.getElementById("divTabHomeDashboard-0").click();
    }
});

